import Snowflake from '../../views/Snowflake';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';

const mapStateToProps = (state, ownProps) => ({
  locale: ownProps.match.params.locale,
  groupId: state.shift.auth.groupId,
  gitlab_id: state.shift.auth.gitlab_id,
  role: state.shift.auth.role,
  status: state.shift.status,
  username: state.shift.auth.username,
  customerid: state.shift.auth.customerid,
  transactions: state.shift.assessment.transactions,
  usersapproveList: state.shift.assessment.usersapproveList,
  customersList:state.shift.assessment.customersList,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    gitlabProjects: (username,path) => (
       dispatch(push(`/${locale}/assessment/${path}`))
      ),

    gitlabProjectsForTrans: (props) => {
      dispatch(push(`/${locale}/translation`))
    },

    clickHelpHandler: value => {
      dispatch(push(`/${locale}/assessmenthelp`));
    },

    gotoManagement: ()=>{
      dispatch(push(`/${locale}/management`));
    },

    gotoDatafactorymanagement: ()=>{
      dispatch(push(`/${locale}/datafactorymanagement`));
    },

    gotoDatafactorymanagement2: ()=>{
      dispatch(push(`/${locale}/createdatafactory`));
    },

    gotoDashboard: ()=>{
      dispatch(push(`/${locale}/dashboard`));
    },

    getCustomers: ()=>{
      dispatch(actions.customersList());
      dispatch(actions.resetCustomersPrjList());
      dispatch(actions.resetStagingPrjList());
    },

    RequestList: username => {
      dispatch(actions.RequestList(username));
    },

    getusersList: username => {
       dispatch(actions.usersapproveList());
    },

    NPRequestList: customer =>{
      dispatch(actions.NPRequestList(customer));
    },

    customerApprove: (id,fun) =>{
      dispatch(actions.customerApprove(id)).then(
        ()=>{fun()}
      )
    },

    customerdeactivate: (customer,fun) =>{
      console.log(customer);
      dispatch(actions.customerdeactivate(customer)).then(()=>{fun()});
    },

    customerrectivate: (customer,fun) =>{
      dispatch(actions.customerrectivate(customer)).then(()=>{fun()});
    },


  };
};

const SnowflakeComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Snowflake);

export default SnowflakeComponent;



// WEBPACK FOOTER //
// ./src/components/container/Snowflake/index.js